import { createSelector, createStructuredSelector } from "reselect"

// components
import { PoliticalCommitteeCandidateGrid } from "profiles/components/CandidateGrid"
import {
    PoliticalCommitteeAffiliatedCommitteeGrid,
    PoliticalCommitteeJointFundraiserCommitteeGrid,
    PoliticalCommitteeJointFundraiserRepresentativeGrid,
} from "profiles/components/CommitteeGrid"
import { DesignSystemDataTableView } from "profiles-new/components/DataTableView/index"
import ContactCard from "profiles-new/components/ContactCard"
import { PoliticalCommitteeHTMLTableSummary } from "profiles/components/HTMLTableSummary"

// selectors
import * as sharedSelectors from "shared/profiles/political-committee/political-committee-selectors"
import { selectTabs } from "shared/profiles/tabs/politicalCommitteeTabSelector"
import * as sharedSelectorsNew from "shared/profiles/official/official-profile-selectors"
import { selectFirstLedgerSettingsId } from "shared/pac/selectors"

// helpers
import { checkPermission } from "shared/imports/permissionFunctions"
import isFeatureEnabled from "shared/featureflags/helperFunctions"

export const politicalCommitteeProfileSelectors = createStructuredSelector({
    tabs: selectTabs({ isMobile: false }),
    headerTitle: sharedSelectors.selectTitle,
    qdt: () => DjangIO.app.models.QuorumDataType.political_committee,
    isLoading: sharedSelectors.selectIsLoadingPoliticalCommitteeProfile,
    ledgerSettingsId: selectFirstLedgerSettingsId,
})

export const politicalCommitteeProfileSelectorsMobile = createStructuredSelector({
    member: sharedSelectorsNew.selectMember,
})

export const selectPoliticalCommitteeSections = createSelector(
    sharedSelectors.selectContactCardData({ sectionComponent: ContactCard }),
    sharedSelectors.selectAbout({ sectionComponent: DesignSystemDataTableView }),
    sharedSelectors.selectCandidateSection({ sectionComponent: PoliticalCommitteeCandidateGrid }),
    sharedSelectors.selectAffiliatedCommitteeSection({ sectionComponent: PoliticalCommitteeAffiliatedCommitteeGrid }),
    sharedSelectors.selectJointFundraisingCommitteeSection({
        sectionComponent: PoliticalCommitteeJointFundraiserCommitteeGrid,
    }),
    sharedSelectors.selectJointFundraisingRepresentativeSection({
        sectionComponent: PoliticalCommitteeJointFundraiserRepresentativeGrid,
    }),
    sharedSelectors.selectTableSection({ sectionComponent: PoliticalCommitteeHTMLTableSummary }),
    sharedSelectors.selectCandidateId,
    sharedSelectors.selectNumAffiliatedCommittees,
    sharedSelectors.selectNumJointFundraisingCommittees,
    sharedSelectors.selectNumJointFundraisingRepresentatives,
    sharedSelectorsNew.selectMember,
    (
        contactCard,
        about,
        candidate,
        affiliated,
        jfcSection,
        jfrSection,
        transactionSummaryTable,
        candidateId,
        affiliatedCommitteesExist,
        jfcExist,
        jfrExist,
    ) =>
        [
            contactCard,
            about,
            ...(candidateId ? [candidate] : []),
            ...(affiliatedCommitteesExist ? [affiliated] : []),
            ...(jfcExist ? [jfcSection] : []),
            ...(jfrExist ? [jfrSection] : []),
            ...(checkPermission(DjangIO.app.models.PermissionType.qpac_v1) &&
            (!isFeatureEnabled("ff_pac_permissions_one") || Userdata.can_view_pac_receipts)
                ? [transactionSummaryTable]
                : []),
        ].filter((section) => section),
)

export const selectShouldRenderEditButton = createSelector(
    sharedSelectors.selectOrganization,
    (organization) => checkPermission(DjangIO.app.models.PermissionType.pac_state_and_local_committees) && organization,
)

export const actionButtonSelectors = createStructuredSelector({
    shouldRenderFavoriteButton: () => false,
    qdt: () => DjangIO.app.models.QuorumDataType.political_committee.value,
    shouldRenderEditButton: selectShouldRenderEditButton,
})
